import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X3LevelStore} from '../X3LevelStore';

@observer
export class AddUnitControls extends React.Component<{ store: X3LevelStore }> {
  render() {
    const {store} = this.props;

    if (store.addUnit === null)
      return null;

    const addUnit = store.addUnit;
    const isPending = addUnit.save?.isPending === true;

    return (<>
      <div className="row justify-content-end">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.completeAdd}
                  disabled={isPending}>
            Save
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.cancel}
                  disabled={isPending}>
            Cancel
          </button>
        </div>
      </div>

      <PromiseMessage label="Saving" state={addUnit.save} align="right"/>
    </>);
  }
}
